import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const DownloadPdf = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none">
    <path
      d="M2.66675 10.666V11.3327C2.66675 11.8631 2.87746 12.3718 3.25253 12.7469C3.62761 13.122 4.13631 13.3327 4.66675 13.3327H11.3334C11.8638 13.3327 12.3726 13.122 12.7476 12.7469C13.1227 12.3718 13.3334 11.8631 13.3334 11.3327V10.666M5.33341 7.99935L8.00008 10.666L10.6667 7.99935M8.00008 10.666V2.66602"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DownloadPdf;
